// Generated by Melange

import * as Component from "@loadable/component";
import * as Buhta_cabinet__App from "./App.js";
import * as Buhta_cabinet__Data from "./core/Data.js";
import * as Buhta_conf__Apm from "../../../packages/conf/lib/Apm.js";
import * as Buhta_conf__Config from "../../../packages/conf/lib/Config.js";
import * as Curry from "melange.js/curry.js";
import * as ReasonReactErrorBoundary from "reason-react/ReasonReactErrorBoundary.js";
import * as React from "react";
import * as Client from "react-dom/client";
import * as ReactPdf from "react-pdf";
import * as JsxRuntime from "react/jsx-runtime";

((require('../../../resources/styles/index-cabinet.css')
  ));

((require('../../../resources/styles/cropper.css')
  ));

((require('react-pdf/dist/Page/AnnotationLayer.css')
  ));

((require('react-pdf/dist/Page/TextLayer.css')
  ));

ReactPdf.pdfjs.GlobalWorkerOptions.workerSrc = (new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString()
);

const apm = Buhta_conf__Apm.init(undefined);

function renderOrHydrate(component) {
  const element = Curry._1(component, undefined);
  return Component.loadableReady(function (param) {
    Client.hydrateRoot(document, JsxRuntime.jsx(React.StrictMode, {
      children: JsxRuntime.jsx(ReasonReactErrorBoundary.make, {
        children: element,
        fallback: (function (param) {
          console.log("err", param.error);
          return "Some error happened";
        })
      })
    }));
  });
}

const state = Buhta_conf__Config.getState(undefined);

const data = Buhta_cabinet__Data.getData(undefined);

renderOrHydrate(function (param) {
  return JsxRuntime.jsx(Buhta_cabinet__App.make, {
    state: state,
    data: data
  });
});

export {
  apm,
  renderOrHydrate,
  state,
  data,
}
/*  Not a pure module */
